module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.d14ad103.ttf";